import { PAGES } from '../../config';
import { Cookies } from '../../utils';

if (!window.atob) {
	const Base64 = require('Base64');
	window.atob = Base64.atob;
}

const analyticsCookieName = 'TODO';

/* global _kmq b:true */

const cookies = new Cookies(analyticsCookieName);

/**
 * pushes a 'page view' to kissmetrics
 * @description by convention, all 'jg analytics' providers
 * (that is, all analytics*.js files in this dir) should share
 * the same interface.
 * @param {string} pageName
 * @param {object} data - pertinent tracking data
 */
export const trackPageView = (pageName, data) => {
	if (window._kmq) {
		_kmq.push([
			'record',
			'page view',
			{
				'page_type': '',
				'event': 'page view',
				'subtype': pageName,
				'page_section': '',
				'actor_id': '',
				'actor_sources': '',
				'content_id': '',
				'content_type': '',
				'logged_in_guid': cookies.analyticsCookie.logged_in_guid || '',
				'logged_out_guid': cookies.analyticsCookie.logged_out_guid || '',
				'ab_logged_in_guid': cookies.JgAbLoggedInCookie.value || '',
				// TODO: 'session_id': cookie['ASP.NET_SessionId']
				//       The analytics guys want this, but as it's not readily
				//       available, we won't be pushing it for now.
				'url': window.location.href || '',
				'referrer': document.referrer || 'direct',
				'user_agent': window.navigator.userAgent || '',
			},
		]);
	}
};

/**
 * setIdentity
 * @desc decodes jwt and extracts the users email address.
 * sends email to kissmetrics to identify the logged in session
 * uses Base64 as a polyfill for atob
 * @param {string} JWT
 * */
export const setIdentity = JWT => {
	if (!JWT) {
		return;
	}
	const jwtChunks = JWT.split('.');
	const jwtChunk = jwtChunks && jwtChunks[1];
	const email = jwtChunk && JSON.parse(window.atob(jwtChunk)).unique_name;

	(window._kmq && email) && window._kmq.push(['identify', email]);
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/lib/analytics/analytics-kissmetrics.js